import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import { useFinder } from "../../../modules/finder";
import BIMClassCard from "../../products/ui/components/entities/bimClass/BIMClassCard";
import SearchBimClasses from "../domain/Search/SearchBimClasses.graphql";

/**
 * Finder plugin for BimClasses, shaped like products' entity finder plugins
 * (see CountryFinderPlugin in apps/console) but backed by the taxonomy
 * `searchBimClasses` query instead of an in-memory list.
 */

/** Matches the standalone taxonomy selector: shorter tokens match far too much. */
const MINIMUM_TOKEN_LENGTH = 3;

export default function BimClassFinderPlugin(props) {
    const { exclude = [], onSelect } = props;

    const { token } = useFinder();

    const searchBimClasses = useQuery(
        gql(SearchBimClasses),
        {
            skip: token.length < MINIMUM_TOKEN_LENGTH,
            variables: {
                term: token,
            },
        },
    );

    if (token.length < MINIMUM_TOKEN_LENGTH) {
        return <li>type at least { MINIMUM_TOKEN_LENGTH } characters</li>;
    }

    if (searchBimClasses.loading) return <li>searching…</li>;
    if (searchBimClasses.error) return <li>search failed</li>;

    const results = searchBimClasses.data.searchBimClasses
        .filter((bimClass) => !exclude.includes(bimClass.id))
        .toSorted((a, b) => a.data.name[0].text.localeCompare(b.data.name[0].text));

    if (!results.length) return <li>no unassigned matches</li>;

    return results.map(
        (bimClass) => (
            <li key={ bimClass.id }>
                <BIMClassCard
                    id={ bimClass.id }
                    name={ bimClass.data.name[0].text }
                    onClick={
                        () => onSelect(
                            {
                                id: bimClass.id,
                                name: bimClass.data.name[0].text,
                            }
                        )
                    }
                />
            </li>
        )
    );
}
